export default "/images/ubicacion.svg?01b2e61c7d1c1466edfb5ae6c551c51e";